import { CUSTOM_FIELD_TYPE_READABLE_NAME_MAP } from '@payaca/custom-fields';
import { MAX_FIELDSET_DEPTH } from '@payaca/custom-fields/constants/index';

const LEAF_TYPE_OPTIONS = [
  { value: 'text', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['text'] },
  { value: 'textarea', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['textarea'] },
  { value: 'email', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['email'] },
  { value: 'select', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['select'] },
  {
    value: 'multi-select',
    label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['multi-select'],
  },
  { value: 'boolean', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['boolean'] },
  { value: 'number', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['number'] },
  { value: 'date', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['date'] },
  { value: 'url', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['url'] },
  { value: 'upload', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['upload'] },
  { value: 'user', label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['user'] },
];

const FIELDSET_TYPE_OPTION = {
  value: 'fieldset',
  label: CUSTOM_FIELD_TYPE_READABLE_NAME_MAP['fieldset'],
};

export type TypeOption = { value: string; label: string; disabled?: boolean };

/**
 * Returns the available field type options based on nesting depth.
 * At maximum depth, only leaf types are allowed (no nested fieldsets).
 * For persisted fields, fieldset is disabled because the backend cannot
 * convert a leaf field into a fieldset (it requires children).
 */
export function getTypeOptionsForField(
  /** Current nesting depth (1 for root fieldset children, 2 for nested fieldset children) */
  depth: number,
  /** Whether the field has already been saved */
  isPersisted?: boolean
): TypeOption[] {
  if (depth >= MAX_FIELDSET_DEPTH) {
    return LEAF_TYPE_OPTIONS;
  }

  return [
    ...LEAF_TYPE_OPTIONS,
    isPersisted
      ? { ...FIELDSET_TYPE_OPTION, disabled: true }
      : FIELDSET_TYPE_OPTION,
  ];
}
